import "@m2s/design-system/tokens.css";
import "@/styles/index.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";

import { queryClient } from "@/lib/queryClient";
import { AuthProvider } from "@/providers/AuthProvider";
import { router } from "@/routes";
import { applyTheme, useUIStore } from "@/store/ui";

// The inline script in index.html paints the theme before this bundle loads;
// re-apply here as the JS source of truth, then follow live OS changes while
// the preference is "system".
applyTheme(useUIStore.getState().theme);
if (typeof window !== "undefined" && window.matchMedia) {
  window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", () => {
    if (useUIStore.getState().theme === "system") applyTheme("system");
  });
}

// TanStack Query Devtools shipped a tropical-island floater in dev mode that
// looked like brand noise. Disabled by default; re-enable by setting
// VITE_SHOW_QUERY_DEVTOOLS=1 in .env.local if you actually need it.
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
